/*
 * Copyright (c) 2022 CalAmp Corp.  All Rights Reserved
 */
import {createSelector} from 'reselect';
import {selectIsProfileEnabled} from './admin-users';
import {selectInitializationComplete} from './initialization';

export const responsiveHeaderSelector = createSelector([
  selectIsProfileEnabled
], (isProfleEnabled): boolean => (
  isProfleEnabled
));

export const previewLegacySelector = createSelector([
  selectInitializationComplete
], (isFromLegacyAdmin): boolean => (
  isFromLegacyAdmin
));
